import { render } from "./TabMental.vue?vue&type=template&id=189b7fc0"
import script from "./TabMental.vue?vue&type=script&lang=js"
export * from "./TabMental.vue?vue&type=script&lang=js"
script.render = render

export default script